import { render } from "./JoinFailPopup.vue?vue&type=template&id=4c54876f&scoped=true&ts=true"
import script from "./JoinFailPopup.vue?vue&type=script&lang=ts"
export * from "./JoinFailPopup.vue?vue&type=script&lang=ts"

import "./JoinFailPopup.vue?vue&type=style&index=0&id=4c54876f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c54876f"]])

export default __exports__